"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import { useTrackingConsent } from "@/hooks/useTrackingConsent";

// Advertising consent only.
export function TiktokPixelCookieSetter(): null {
  const searchParams = useSearchParams();
  const { advertisement } = useTrackingConsent();

  useEffect(() => {
    if (!advertisement) return;
    const ttclid = searchParams.get("ttclid");
    if (ttclid) {
      const expires = new Date();
      expires.setDate(expires.getDate() + 90);
      document.cookie = `ttclid=${encodeURIComponent(ttclid)}; expires=${expires.toUTCString()}; path=/; SameSite=Lax; Secure`;
    }
  }, [advertisement, searchParams]);

  return null; // This component does not render anything
}
